/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Achievements_TitleInputs */

const en_us2_progress_extra_achievements_title = /** @type {(inputs: Progress_Extra_Achievements_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievements`)
};

const pt_br2_progress_extra_achievements_title = /** @type {(inputs: Progress_Extra_Achievements_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conquistas`)
};

const es_419_progress_extra_achievements_title = /** @type {(inputs: Progress_Extra_Achievements_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logros`)
};

const pt_pt2_progress_extra_achievements_title = /** @type {(inputs: Progress_Extra_Achievements_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conquistas`)
};

const fr_fr2_progress_extra_achievements_title = /** @type {(inputs: Progress_Extra_Achievements_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succès`)
};

const de_de2_progress_extra_achievements_title = /** @type {(inputs: Progress_Extra_Achievements_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfolge`)
};

const it_it2_progress_extra_achievements_title = /** @type {(inputs: Progress_Extra_Achievements_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traguardi`)
};

/**
* | output |
* | --- |
* | "Achievements" |
*
* @param {Progress_Extra_Achievements_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_achievements_title = /** @type {((inputs?: Progress_Extra_Achievements_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Achievements_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_achievements_title(inputs)
	if (locale === "es-419") return es_419_progress_extra_achievements_title(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_achievements_title(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_achievements_title(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_achievements_title(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_achievements_title(inputs)
	return en_us2_progress_extra_achievements_title(inputs)
});
export { progress_extra_achievements_title as "progress-extra.achievements_title" }